"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lodash = _interopRequireDefault(require("lodash"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Colors = require("../../utils/Colors");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Badge = function Badge(props) {
  var id = props.id,
      className = props.className,
      color = props.color,
      text = props.text;

  if (text === '' || text === undefined) {
    return null;
  }

  var luma = (0, _Colors.getColorLuma)(color);

  var style = _lodash["default"].assign({}, {
    color: luma < 128 ? 'white' : '#4A657F',
    backgroundColor: props.color
  }, props.style);

  var badgeClass = function badgeClass() {
    return (0, _classnames["default"])({
      badge: true,
      'badge--square': props.shape === 'square'
    }, className);
  };

  return /*#__PURE__*/_react["default"].createElement("span", {
    id: id,
    className: badgeClass(),
    style: style
  }, text);
};

Badge.propTypes = {
  /** id for reference */
  id: _propTypes["default"].string,

  /** className for reference */
  className: _propTypes["default"].string,

  /** content to display */
  text: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /** Hex color code */
  color: _propTypes["default"].string.isRequired,

  /** Override the inline-styles of the root element || Not Recommended */
  style: _propTypes["default"].object,

  /** Shape of the badge */
  shape: _propTypes["default"].oneOf(['square', 'circle'])
};
Badge.defaultProps = {
  id: '',
  className: '',
  text: '',
  color: '#E53935',
  style: {},
  shape: 'circle'
};
var _default = Badge;
exports["default"] = _default;